// extracted by mini-css-extract-plugin
module.exports = {"container":"devhub-layout_container__CRfzw","content":"devhub-layout_content__4BuJT","fixed-width":"devhub-layout_fixed-width__Z3kns"};